<script setup lang="ts">
import socialLinks from '~/constants/social-links'
</script>

<template>
  <footer class="relative z-20 bg-white dark:bg-neutral-900 border-t border-neutral-200 dark:border-neutral-700 text-neutral-700 dark:text-neutral-200">
    <UContainer>
      <div class="py-4 border-b border-neutral-200 dark:border-neutral-700 mb-4 text-sm flex items-center">
        <div>Ongehoord {{ new Date().getFullYear() }}</div>
        <div class="ml-auto flex gap-2">
          <UButton
            v-for="socialLink in socialLinks"
            :key="socialLink.label"
            :to="socialLink.url"
            :icon="socialLink.icon"
            target="_blank"
            color="neutral"
            rel="noopener noreferrer"
            size="sm"
            variant="ghost"
          />
        </div>
      </div>
      <div class="grid md:grid-cols-3 gap-4">
        <ApplicationFooterSectionsContact />
        <ApplicationFooterSectionsDonate />
        <ApplicationFooterSectionsInvestigations />
      </div>
    </UContainer>
  </footer>
</template>
